const FixedHeaderShadow = () => {

    return <div className="fixed-header" style={{position: "absolute", bottom: 1, left: 0, zIndex: -1, pointerEvents: "none", height: "100vh", width: "100%" }} />;
};

export default FixedHeaderShadow;
